import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const LOGO_URL = "https://customer-assets-jt897jd0.emergentagent.net/job_tanzania-explorer/artifacts/51ea8db6791139b2_Screenshot%202026-09-29%20at%205.44.28%E2%80%AFPM.png";
export const WHATSAPP_NUMBER = "+14315882255";
export const WHATSAPP_DISPLAY = "+1 (431) 588-2255";
export const WHATSAPP_URL = `https://wa.me/14315882255`;

export const CONTACT_EMAIL = "info@apexsafarisintz.com";
export const INSTAGRAM_HANDLE = "apexsafaristz";
export const INSTAGRAM_URL = `https://www.instagram.com/${INSTAGRAM_HANDLE}/`;

export const waLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER.replace(/\D/g, "")}${message ? `?text=${encodeURIComponent(message)}` : ""}`;

export const api = axios.create({ baseURL: API });
